import { Button, Space, Table, Tag } from "antd";
import dayjs from "dayjs";
import {
  EyeOutlined,
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

export const statusColors = {
  ACTIVE: { bg: "#e6fffb", color: "#006d75", border: "#87e8de" },
  INACTIVE: { bg: "#fff2f0", color: "#cf1322", border: "#ffa39e" },
};

export const typeColors = {
  BANK_ACCOUNT: { bg: "#e6f7ff", color: "#096dd9", border: "#91d5ff" },
  CARD: { bg: "#fff0f6", color: "#c41d7f", border: "#ffa3c7" },
};

export const defaultColors = {
  TRUE: { bg: "#f6ffed", color: "#389e0d", border: "#b7eb8f" },
};

export const getTagStyle = (type, value) => {
  let colors;

  if (type === "status") colors = statusColors[value];
  else if (type === "type") colors = typeColors[value];
  else if (type === "default") colors = defaultColors[value];

  return {
    backgroundColor: colors?.bg || "#f5f5f5",
    color: colors?.color || "#000",
    padding: "2px 10px",
    borderRadius: "6px",
    fontSize: "0.65rem",
    border: `1px solid ${colors?.border || "#d9d9d9"}`,
    fontWeight: 600,
    cursor: "default",
  };
};

export default function ExternalAccountsTable({ accounts = [], loading }) {
  const columns = [
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      render: (type) => <Tag style={getTagStyle("type", type)}>{type}</Tag>,
    },
    {
      title: "Bank / Brand",
      key: "bank",
      render: (_, record) => record.bankName || record.brand || "-",
    },
    {
      title: "Last 4",
      dataIndex: "last4",
      key: "last4",
      render: (v) => (v ? `**** ${v}` : "-"),
    },
    {
      title: "Currency",
      dataIndex: "currency",
      key: "currency",
      render: (v) => v?.toUpperCase(),
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Default",
      key: "default",
      render: (_, record) =>
        record.isDefaultPaymentAccount ? (
          <Tag style={getTagStyle("default", "TRUE")}>DEFAULT</Tag>
        ) : (
          "-"
        ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag style={getTagStyle("status", status)}>{status}</Tag>
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={accounts}
      pagination={{ pageSize: 10 }}
      loading={loading}
      className="custom-table"
      size="small"
      // scroll={{ x: 400 }}
      expandable={{
        expandedRowRender: (record) => (
          <div style={{ paddingLeft: 50 }}>
            <p className="mb-2 pb-0">
              <strong>External Account ID:</strong> {record.externalAccountId}
            </p>
            {record.type === "BANK_ACCOUNT" && (
              <p className="mb-2 pb-0">
                <strong>Bank Name:</strong> {record.bankName}
              </p>
            )}
            {record.type === "CARD" && (
              <p className="mb-2 pb-0">
                <strong>Brand:</strong> {record.brand}
              </p>
            )}
            <p className="mb-2 pb-0">
              <strong>Default for Currency:</strong>{" "}
              {record.isDefaultForCurrency ? "Yes" : "No"}
            </p>
            <p className="mb-2 pb-0">
              <strong>Added At:</strong>{" "}
              {record.addedAt
                ? dayjs(record.addedAt).format("YYYY-MM-DD HH:mm")
                : "-"}
            </p>
            <p className="mb-2 pb-0">
              <strong>Updated At:</strong>{" "}
              {record.updatedAt
                ? dayjs(record.updatedAt).format("YYYY-MM-DD HH:mm")
                : "-"}
            </p>
          </div>
        ),
        rowExpandable: (record) => true,
      }}
    />
  );
}
